import {getData} from "../api/get-data";

export const setReduceCart = (itemId, resolveHandler) => {
  getData({
    [`set_cart`]: {
      [`item_id`]: itemId,
      [`action`]: `reduce`,
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
